(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-asset-type-attribute', {
            parent: 'entity',
            url: '/custom-asset-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customAssetTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attributes.html',
                    controller: 'CustomAssetTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customAssetTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-asset-type-attribute-detail', {
            parent: 'custom-asset-type-attribute',
            url: '/custom-asset-type-attribute/{id}',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customAssetTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-detail.html',
                    controller: 'CustomAssetTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customAssetTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomAssetTypeAttribute', function($stateParams, CustomAssetTypeAttribute) {
                    return CustomAssetTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-asset-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-asset-type-attribute-detail.edit', {
            parent: 'custom-asset-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomAssetTypeAttribute', function(CustomAssetTypeAttribute) {
                            return CustomAssetTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
       /* .state('custom-asset-type-attribute.new', {
            parent: 'custom-asset-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-asset-type-attribute', null, { reload: 'custom-asset-type-attribute' });
                }, function() {
                    $state.go('custom-asset-type-attribute');
                });
            }]
        })*/
        
        .state('custom-asset-type-attribute.new', {
			parent : 'custom-asset-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-asset-type-attribute.edit', {
            parent: 'custom-asset-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomAssetTypeAttribute', function(CustomAssetTypeAttribute) {
                            return CustomAssetTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-asset-type-attribute', null, { reload: 'custom-asset-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-asset-type-attribute.edit', {
			parent : 'custom-asset-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customAssetTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customAssetTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomAssetTypeAttribute', function($stateParams, CustomAssetTypeAttribute) {
					return CustomAssetTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-asset-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
		
        .state('custom-asset-type-attribute.delete', {
            parent: 'custom-asset-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-delete-dialog.html',
                    controller: 'CustomAssetTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomAssetTypeAttribute', function(CustomAssetTypeAttribute) {
                            return CustomAssetTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-asset-type-attribute', null, { reload: 'custom-asset-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
